/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FacetNavigationPriceRangePicker } from '@/components/content/HelloRetailFacetNavigation/parts/PriceRangePicker';
import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { Chip } from '@mui/material';
import { ContentContext } from '@/data/context/content';
import { FC, useCallback, useContext } from 'react';
import { useHelloRetailSearch } from '@/data/Content/HelloRetailSearch';
import { INIT_PRICE_RANGE } from '@/data/constants/HelloretailSearch';

export const FacetNavigationPrice: FC = () => {
	
	const {
            priceRange,
            handlePriceFilterChange
    } = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;
    
	const minPrice = priceRange?.minPrice??-1;
	const maxPrice = priceRange?.maxPrice??-1;


	const onDelete = useCallback(
		() => handlePriceFilterChange(INIT_PRICE_RANGE),
		[handlePriceFilterChange]
	);

	return minPrice > -1 && maxPrice > -1 ? (
		<Chip
			size="medium"
			label={<PriceDisplay min={minPrice} max={maxPrice} />}
			onClick={onDelete}
			onDelete={onDelete}
			data-testid="product-filter-formatted-price-chip"
			id="product-filter-formatted-price-chip"
		/>
	) : (
		<FacetNavigationPriceRangePicker />
	);
};
